import { SectionLabel } from "@/components/shared/SectionLabel";
import { RevealText } from "@/components/shared/RevealText";
import { ProcessSteps } from "@/components/shared/ProcessSteps";
import { CTAButton } from "@/components/shared/CTAButton";
import { PROCESS_STEPS } from "@/data/siteData";

export const HowItWorks = () => (
  <section className="py-24 px-6 bg-white">
    <div className="max-w-7xl mx-auto">
      <div className="max-w-2xl mb-16">
        <SectionLabel>How It Works</SectionLabel>
        <RevealText
          as="h2"
          text="A Simple Recruitment Process"
          className="font-heading text-3xl sm:text-4xl font-semibold text-navy tracking-tight leading-tight"
        />
      </div>
      <ProcessSteps steps={PROCESS_STEPS} />
      <div className="mt-16 text-center">
        <CTAButton to="/contact-us#enquiry" variant="secondary" testId="how-it-works-cta">
          Start Your Recruitment Requirement
        </CTAButton>
      </div>
    </div>
  </section>
);
